module.exports = __webpack_public_path__ + "media/react/pages/add_ons/assets/admissions/headshot_linnea-6c64a8f81b52b27d5f60b0b3d9ccbb84.jpg";